import { isMockServices } from 'src/utils';
import { QueryFunction } from '@tanstack/react-query';
import mock from '../utils/mock';
import { authTokenHttp } from '../utils/authTokenHttp';
import type { IncomeResponse } from './types.d';
import { mockIncomeData } from './mockData';
import { INCOME_ERROR_MESSAGES } from './errorMessages';
import { handleIncomeClarity404Error } from './errorHandlers';
import { MosError } from 'src/utils/errors/MosError';

export interface GetIncomeParams {
  loanId: string;
}

const getIncome: QueryFunction<
  IncomeResponse,
  ['/income', GetIncomeParams]
> = async ({ queryKey }) => {
  const [, params] = queryKey;
  if (isMockServices()) {
    return await mock(mockIncomeData);
  }

  try {
    const response = await authTokenHttp<IncomeResponse>(
      `/loans/${params.loanId}/income-clarity`,
      {
        method: 'GET',
      },
    );

    if (!response.data) {
      throw new Error(INCOME_ERROR_MESSAGES.NO_DATA);
    }

    if (!response.data.success) {
      throw new Error(INCOME_ERROR_MESSAGES.INCOME_CLARITY_FAILED);
    }

    return response.data;
  } catch (error) {
    // Handle 404 as "no income data available yet" - return empty state
    if (error instanceof MosError && error.statusCode === 404) {
      return handleIncomeClarity404Error(error) as unknown as IncomeResponse;
    }

    // Re-throw other errors
    throw error;
  }
};

export default getIncome;
